import React from 'react';
import { ChainIcon } from '../ChainIcon';

export const SwapStatusAlerts = ({
  isConnected,
  isWalletNetworkAligned,
  selectedChainKey,
  selectedChain,
  chainReadinessMessage,
}) => {
  return (
    <>
      {isConnected && !isWalletNetworkAligned && (
        <div
          className="status error"
          style={{ margin: '0 24px 16px' }}
          role="alert"
          aria-live="assertive"
        >
          <div className="status-message-row">
            <ChainIcon chainKey={selectedChainKey} size={14} />
            <span>
              Wrong network. Please switch to {selectedChain?.networkLabel || 'the correct network'}
              .
            </span>
          </div>
        </div>
      )}

      {chainReadinessMessage && (
        <div className="status info chain-readiness" role="status" aria-live="polite">
          <div className="status-message-row">
            <ChainIcon chainKey={selectedChainKey} size={14} />
            <span>{chainReadinessMessage}</span>
          </div>
        </div>
      )}
    </>
  );
};
